<template>
  <div class="c-gnav" :class="{'c-gnav--black': headBlack}">
    <header id="c-header" class="c-header">
      <a class="c-header__logo" :href="`/collections/luxury/2023/${pathPrefix}`"></a>
      <div class="c-header__nav">
        <ul class="is-link">
          <li><router-link :to="`/${pathPrefix}`">Home</router-link></li>
          <li><a :href="this.$store.getters.shoplistURL[this.lang]" target="_blank">Shop List</a></li>
        </ul>
        <ul class="is-lang">
          <li><a href="/collections/luxury/2023/" @click.prevent="changeLang('ヘッダ')">JP</a></li>
          <li><a href="/collections/luxury/2023/en/" @click.prevent="changeLang('ヘッダ')">EN</a></li>
        </ul>
      </div>
    </header>

    <div class="c-gnav__modal">
      <ul class="is-link">
          <li><a :href="`/collections/luxury/2023/${pathPrefix}`" @click.prevent="gotoHome()">Home</a></li>
          <li><a :href="this.$store.getters.shoplistURL[this.lang]" target="_blank">Shop List</a></li>
          <li><a :href="this.$store.getters.officialURL[this.lang]" target="_blank">Official site</a></li>
        </ul>
      <ul class="is-sns">
        <li>
          <a href="https://www.facebook.com/FourNines.co.jp" target="_blank">
            <img :src="`${$store.getters.assetsPath}img/footer/btn-fb@2x.png`" alt="facebook" width="32" height="32" />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/999.9_fournines/" target="_blank">
            <img :src="`${$store.getters.assetsPath}img/footer/btn-insta@2x.png`" alt="instagram" width="32" height="32" />
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/channel/UCMsksMVNqQdUeCGkAAjpTMA" target="_blank">
            <img :src="`${$store.getters.assetsPath}img/footer/btn-youtube@2x.png`" alt="youtube" width="32" height="32" />
          </a>
        </li>
        <li>
          <a href="https://page.line.me/545vwtra?openQrModal=true" target="_blank">
            <img :src="`${$store.getters.assetsPath}img/footer/btn-line@2x.png`" alt="line" width="32" height="32" />
          </a>
        </li>
      </ul>
      <ul class="is-lang">
        <li><a href="/collections/luxury/2023/" @click.prevent="changeLang('スマホメニュー')">JP</a></li>
        <li><a href="/collections/luxury/2023/en/" @click.prevent="changeLang('スマホメニュー')">EN</a></li>
      </ul>
    </div>

    <div class="c-gnav__trigger" @click="toggle">
        <div class="is-open">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="is-close">
          <span></span>
          <span></span>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      lang: '',
      pathPrefix: '',
    }
  },
  computed: {
    headBlack() {
      return this.$store.getters.headBlack;
    },
  },
  mounted() {
    this.lang = this.$store.getters.lang;
    this.pathPrefix = this.$store.getters.pathPrefix;
  },
  methods: {
    once() {

    },
    start() {

    },
    toggle() {
      if (this.isOpen) {
        this.isOpen = false;
        this.closeModal();
      } else {
        this.isOpen = true;
        this.openModal();
      }
    },
    openModal() {
      this.$el.classList.add('c-gnav--open');
    },
    closeModal() {
      this.$el.classList.remove('c-gnav--open');
    },
    forceClose() {
      this.isOpen = false;
      this.closeModal();
    },
    gotoHome() {
      if (this.$route.name !== 'index') {
        this.$router.push('/');
      } else {
        location.reload();
      }
    },
    changeLang(log) {
      if (this.$store.getters.lang === 'en') {
        // 日本語版へ
        let path = '';
        if (this.$route.name !== 'en_index') {
          path = `${this.$route.name.replace('en_','')}/`;
        }
        location.href = `/collections/luxury/2023/${path}`;
      } else {
        // 英語版へ
        let path = '';
        if (this.$route.name !== 'index') {
          path = `${this.$route.name}/`;
        }
        location.href = `/collections/luxury/2023/en/${path}`;
      }
    }
  }
}
</script>